import type { SharedValue } from "react-native-reanimated";
import { useAnimatedStyle } from "react-native-reanimated";
import { StyleSheet } from "react-native-unistyles";

import useAnimatedTheme from "$src/core/hooks/use-animated-theme";

const stylesheet = StyleSheet.create(({ spacing, colors, border }) => ({
  circle: {
    borderRadius: border.radius.full,
    justifyContent: "center",
    alignItems: "center",
    width: spacing(10),
    height: spacing(10),
  },
  circleIcon: {
    color: colors.foregroundDefault,
    width: spacing(6),
    height: spacing(6),
  },
  card: {
    alignItems: "center",
    flexDirection: "row",
    borderWidth: border.widths.md,
    borderColor: colors.borderDefault,
    borderRadius: border.radius.md,
    gap: spacing(5),
    padding: spacing(4),
    minHeight: spacing(24),
    _web: {
      _focus: {
        outline: "none",
      },
      "_focus-visible": {
        outlineStyle: "solid",
        outlineWidth: border.widths.md,
        outlineOffset: border.widths.md,
        outlineColor: colors.borderFocus,
        borderRadius: border.radius.md,
      },
    },
  },
  cardMiddle: {
    flexDirection: "column",
    gap: spacing(2),
    flex: 1,
  },
  cardSubtext: {
    color: colors.foregroundDefault,
  },
  cardText: {
    color: colors.foregroundDefault,
  },
  cardIcon: {
    color: colors.foregroundDefault,
    width: spacing(6),
    height: spacing(6),
  },
}));

export const useAnimatedStyles = ({
  isFocused,
}: {
  isFocused: SharedValue<boolean>;
}) => {
  const animatedTheme = useAnimatedTheme();

  const animatedCardStyle = useAnimatedStyle(() => {
    const { colors } = animatedTheme.value;

    return {
      borderColor: isFocused.value ? colors.borderFocus : colors.borderDefault,
    };
  });

  return {
    animatedCardStyle,
  };
};

export default stylesheet;
